import { EGDSSpacing } from '@egds/react-core/spacing';
import * as React from 'react';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { PropertyPolicies, PropertyPoliciesSplitted } from '@shared-ui/lodging-property-details';
import { RefTarget } from '@shared-ui/ref-context';
import { withSharedUiPropertyDetails } from './shared-ui-property-details';
import { SimpleLazyLoadWrapper } from 'components/common/lazy/simple-lazy-load-wrapper';
import { usePropertyDetailsQueryCSRExperiment } from './use-property-details-query';
const PoliciesWrapper = ({
  inputs
}) => {
  const cSRPropertyDetailsQuery = usePropertyDetailsQueryCSRExperiment();
  return React.createElement(Experiment, {
    name: "Dated_PDP_Split_ProductDetailsQuery"
  }, React.createElement(ExperimentControl, null, React.createElement(EGDSSpacing, {
    margin: {
      block: 'six'
    }
  }, React.createElement(RefTarget, {
    name: "Policies"
  }, React.createElement(SimpleLazyLoadWrapper, null, React.createElement(PropertyPolicies, {
    inputs: inputs,
    skipSsr: cSRPropertyDetailsQuery
  }))))), React.createElement(ExperimentVariant, {
    bucket: 1
  }, React.createElement(EGDSSpacing, {
    margin: {
      block: 'six'
    }
  }, React.createElement(RefTarget, {
    name: "Policies"
  }, React.createElement(SimpleLazyLoadWrapper, null, React.createElement(PropertyPoliciesSplitted, {
    inputs: inputs,
    skipSsr: cSRPropertyDetailsQuery
  }))))));
};
export const SharedUiPoliciesWrapper = withSharedUiPropertyDetails(PoliciesWrapper);
SharedUiPoliciesWrapper.displayName = 'SharedUiPoliciesWrapper';